<mat-selection-list [multiple]="false">    
    <div mat-subheader>{{"KAM-PERMISSIONS-RESOURCES.RESOURCE_SERVERS" | translate}}</div>    
    <mat-list-option  class="kam-resource-servers-list"
        (click)="selectResourceServer(resourceServer)"
        *ngFor="let resourceServer of resourceServers" 
        [value]="resourceServer.clientId">        
            <div class="clientId"><span><mat-icon style="vertical-align: middle;">storage</mat-icon> {{resourceServer.clientId}}</span></div>            
            <div class="name">{{resourceServer.name}}</div>    
    </mat-list-option>
</mat-selection-list>